import gql from 'graphql-tag';

export const UserInfo = gql`
  query userInfoForDesktop {
    me {
      id
      fullName
      email
      canViewContent
      isSsoLogin
      isPlatformAdmin
      isIPA
      dateCreated
      organization {
        id
        name
        theme {
          id
        }
      }
      teams {
        role
        team {
          name
        }
      }
    }
  }
`;
